export function getDeviceFingerprint() {
  const nav = window.navigator;
  const screen = window.screen;
  
  const browser = nav.userAgent;
  const language = nav.language;
  const os = nav.platform;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const resolution = `${screen.width}x${screen.height}`;
  
  // Simple heuristic for device type
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(browser);
  const device_type = isMobile ? 'Mobile' : 'Desktop';
  
  // Create a simple hash string
  const rawString = `${browser}|${language}|${os}|${timezone}|${resolution}|${device_type}`;
  let hash = 0;
  for (let i = 0; i < rawString.length; i++) {
    const char = rawString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0; // Convert to 32bit integer
  }
  
  return {
    hash: hash.toString(),
    browser,
    language,
    os,
    timezone,
    resolution,
    device_type
  };
}
